/**
 * Утилиты для работы с Telegram WebApp API
 */

/**
 * Получает initData из различных источников
 */
export function getTelegramInitData(): string | null {
  // 1. Пробуем получить из window.Telegram.WebApp.initData (самый надежный способ)
  if (window.Telegram?.WebApp?.initData) {
    return window.Telegram.WebApp.initData;
  }

  // 2. Пробуем получить из URL hash (#tgWebAppData=...)
  const hash = window.location.hash;
  if (hash) {
    // Пробуем найти tgWebAppData в hash
    const tgWebAppDataMatch = hash.match(/[#&]tgWebAppData=([^&]*)/);
    if (tgWebAppDataMatch && tgWebAppDataMatch[1]) {
      try {
        // Данные могут быть закодированы несколько раз
        let decoded = decodeURIComponent(tgWebAppDataMatch[1]);
        // Пробуем декодировать еще раз на случай двойного кодирования
        try {
          decoded = decodeURIComponent(decoded);
        } catch {
          // Если не получилось, используем первый результат
        }
        if (decoded && decoded.length > 0) {
          return decoded;
        }
      } catch (e) {
        console.error('Failed to decode tgWebAppData from hash:', e);
      }
    }

    // Альтернативный способ: парсим hash как URLSearchParams
    try {
      const hashParams = new URLSearchParams(hash.substring(1));
      const tgWebAppData = hashParams.get('tgWebAppData');
      if (tgWebAppData) {
        try {
          return decodeURIComponent(decodeURIComponent(tgWebAppData));
        } catch {
          return decodeURIComponent(tgWebAppData);
        }
      }
    } catch (e) {
      // Игнорируем ошибки парсинга
    }
  }

  // 3. Пробуем получить из query параметров (?tgWebAppData=...)
  const searchParams = new URLSearchParams(window.location.search);
  const queryTgWebAppData = searchParams.get('tgWebAppData');
  if (queryTgWebAppData) {
    try {
      return decodeURIComponent(decodeURIComponent(queryTgWebAppData));
    } catch {
      return decodeURIComponent(queryTgWebAppData);
    }
  }

  return null;
}

/**
 * Инициализирует Telegram WebApp
 */
export function initTelegramWebApp(): void {
  if (window.Telegram?.WebApp) {
    try {
      window.Telegram.WebApp.ready();
      window.Telegram.WebApp.expand();
    } catch (error) {
      console.error('Error initializing Telegram WebApp:', error);
    }
  }
}

